import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const ImgWrap = styled.div`
    position: relative;
    flex: 0 0 90px;
    justify-content: center;
    align-items: center;
    width: 90px;
    height: 60px;
    ${FONTS.H4};
    border-radius: 20px;
    overflow: hidden;
    background-color: ${COLORS.BgMain};

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex: 0 0 72px;
        width: 72px;
        height: 48px;
        border-radius: 16px;
    }
`;

export const ImageElement = styled(ImgWrap)<{ imgBgColor?: string, channelCount?: number }>`
    ${p => p.imgBgColor && css`
        background-color: ${p.imgBgColor};
    `};

    ${p => p.channelCount && css`
        &:after {
            content: "+${p.channelCount}";
            position: absolute;
            bottom: 2px;
            right: 19px;
            width: 20px;
            height: 20px;
            ${FONTS.XXS};
            fontSize: 10;
            color: ${COLORS.TextPrimary};
        }

        @media (max-width: ${wideBreakpoints.mobile}) {
            &:after {
                bottom: -1px;
                right: 14px;
            }
        }
    `};

    img {
        width: 100%;
        max-height: 100%;
    }
`;

export const ImageElementWithText = styled(ImgWrap)<{ imgSrc?: string, isMega?: boolean }>`
    overflow: hidden;
    ${FONTS.H3};
    color: ${({ imgSrc, isMega }) => isMega ? COLORS.TextPrimary : (imgSrc ? COLORS.TextWhite : COLORS.TextSecondary)};
    background-color: #E6EEF5;
    background-image: ${({ imgSrc }) => imgSrc ? `url(${imgSrc})` : 'none'};
    background-repeat: no-repeat;
    background-size: cover;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H4};
    }
`;
